<script setup>
defineProps({
  isWebViewProp: {
    type: Boolean,
    default: false
  }
})
</script>

<template>
  <section
    v-if="!isWebViewProp"
    class="block no-ja"
  >
    <div class="sectionTitle">
      <h2 class="title">
        いまおすすめのメニュー
      </h2>
    </div>
    <div class="content">
      <div>
        <NuxtLink
          href="https://weathernews.jp/onebox/radar/"
          class="linkItem"
        >
          <figure class="image">
            <img
              alt=""
              src="https://gvs.weathernews.jp/onebox/img/osusume/image_radar.webp"
              width="40px"
              height="40px"
              loading="lazy"
            >
          </figure>
          <p class="text">
            雨雲レーダー
          </p>
        </NuxtLink>
      </div>
      <div>
        <NuxtLink
          href="https://wxrepo.weathernews.jp/report/"
          class="linkItem"
        >
          <figure class="image">
            <img
              alt=""
              src="https://gvs.weathernews.jp/onebox/img/osusume/image_report.webp"
              width="40px"
              height="40px"
              loading="lazy"
            >
          </figure>
          <p class="text">
            ウェザーリポート
          </p>
        </NuxtLink>
      </div>
      <div>
        <NuxtLink
          href="https://weathernews.jp/s/uv/"
          class="linkItem"
        >
          <figure class="image">
            <img
              src="https://gvs.weathernews.jp/onebox/img/osusume/image_uv.webp"
              width="40px"
              height="40px"
              loading="lazy"
            >
          </figure>
          <p class="text">
            紫外線予報
          </p>
        </NuxtLink>
      </div>
    </div>
  </section>
</template>

<style lang="scss" scoped>
.block {
  display: flex;
  flex-direction: column;
  gap: 10px;
}
.sectionTitle {
  display: flex;
  flex: 1;
  justify-content: space-between;
  align-items: center;
  gap: 6px;
}
.title {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: baseline;
  flex: 1;
  gap: 5px;
  color: #101010;
  font-size: 18px;
  font-weight: 700;
  line-height: 18px;
}
.content {
  display: flex;
  flex-direction: column;
  gap: 5px;
}
.linkItem {
  display: flex;
  flex-direction: row;
  gap: 10px;
  align-items: center;
  width: 100%;
  padding: 8px 10px;
  border: solid 2px #fff;
  border-radius: 8px;
  background-color: #eef1f8;
  box-shadow: 0 2px 4px #00000026;
}
.image {
  width: 40px;
  height: 40px;
  border-radius: 8px;
  overflow: hidden;
}
.text {
  color: #101010;
  font-weight: 700;
  font-size: 15px;
  line-height: 20px;
}
@media screen and (min-width: 830px) {
  .linkItem {
    transition: box-shadow .2s ease-in-out;
  }
}
@media (any-hover: hover) {
  .linkItem {
    transition: box-shadow .2s ease-in-out;
    &:hover {
      box-shadow: 0 2px 6px 0 rgb(0 0 0 / .45);
    }
  }
}
</style>
